import { AvailabilitySearchParameters } from "@/types/AvailabilitySearchParameters";

const constructAvailabilitySearchParametersQuery = (
  availabilitySearchParameters: AvailabilitySearchParameters
): string => {
  const {
    startDate,
    endDate,
    numberOfAdults,
    numberOfChildren,
    childAges,
    numberOfPets,
    customerGroup,
    couponCode,
  } = availabilitySearchParameters;

  let url = `startDate=${startDate}&endDate=${endDate}&numberOfAdults=${numberOfAdults}`;
  if (numberOfChildren > 0) {
    url += `&numberOfChildren=${numberOfChildren}`;
  }
  if (childAges.length > 0) {
    childAges.forEach((age) => {
      url += `&childAges[]=${age}`;
    });
  }
  if (numberOfPets > 0) {
    url += `&numberOfPets=${numberOfPets}`;
  }
  if (customerGroup && customerGroup.length > 0) {
    url += `&customerGroup=${customerGroup}`;
  }
  if (couponCode && couponCode.length > 0) {
    url += `&couponCode=${couponCode}`;
  }

  return url;
};

export default constructAvailabilitySearchParametersQuery;
